import axios from 'axios'
import { store } from 'src/client'
import {
  OrganizationPredictionsSettingsResponse,
  OrganizationSuggestionsSettingsResponse,
  PatchOrganizationPredictionsSettingsRequest,
  PatchOrganizationSuggestionsSettingsRequest,
} from 'src/queries/organizations/automationSettings/automationSettings.types'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const getOrganizationSuggestionsSettings = async (
  orgId: string,
): Promise<OrganizationSuggestionsSettingsResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())

  const response = await axios.get(
    `/organizations/${orgId}/suggestions`,
    requestConfig,
  )

  return response.data as OrganizationSuggestionsSettingsResponse
}

export const getOrganizationPredictionsSettings = async (
  orgId: string,
): Promise<OrganizationPredictionsSettingsResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())

  const response = await axios.get(
    `/organizations/${orgId}/predictions`,
    requestConfig,
  )

  return response.data as OrganizationPredictionsSettingsResponse
}

export const patchOrganizationSuggestionsSettings = async (
  orgId: string,
  request: PatchOrganizationSuggestionsSettingsRequest,
): Promise<OrganizationSuggestionsSettingsResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())

  const response = await axios.patch(
    `/organizations/${orgId}/suggestions`,
    request,
    requestConfig,
  )

  return response.data as OrganizationSuggestionsSettingsResponse
}

export const patchOrganizationPredictionsSettings = async (
  orgId: string,
  request: PatchOrganizationPredictionsSettingsRequest,
): Promise<OrganizationPredictionsSettingsResponse> => {
  const requestConfig = selectAuthedJsonApiRequestConfig(store.getState())

  const response = await axios.patch(
    `/organizations/${orgId}/predictions`,
    request,
    requestConfig,
  )

  return response.data as OrganizationPredictionsSettingsResponse
}
